<template>
  <v-card class="mx-auto thiscard" shaped outlined raised :max-width="maxwidth">
    <v-card-title class="px-3 pb-0">
      <slot name="title" v-if="isEdit"></slot>
      <template v-if="ques.isRequired">
        <v-icon color="primary">mdi-exclamation-thick</v-icon> 必填
      </template>
      <template v-if="ques.isAssign">
        <v-icon color="primary">mdi-exclamation-thick</v-icon> 指定檢核
      </template>
      <!-- 編輯時才會出現的選項：指定檢核、檢查類型、刪除 -->
      <template v-if="isEdit">
        <v-spacer></v-spacer>
        <!-- 該題必填/非必填 -->
        <v-switch
          v-if="showIsRequired"
          v-model="ques.isRequired"
          :disabled="ques.isAssign"
          class="ml-2"
          :label="'必填'"
        ></v-switch>
        <!-- 選項為圖片/非圖片 -->
        <v-switch
          v-if="showIsItemImg"
          v-model="ques.isItemImg"
          class="ml-2"
          :label="ques.isItemImg ? '選項為圖片' : '選項非圖片'"
        ></v-switch>
        <!-- 該題為指定檢核/非指定檢核 -->
        <v-switch
          v-if="showIsAssign"
          :disabled="isAssignDisabled"
          v-model="ques.isAssign"
          class="ml-2"
          :label="ques.isAssign ? '指定檢核' : '非指定檢核'"
        ></v-switch>
        <!-- 該題輸入檢查類型 -->
        <v-select
          v-if="showInputCheck"
          class="ml-2"
          v-model="ques.inputCheck"
          :items="inputCheck"
          item-text="inputCheckName"
          item-value="inputCheck"
          menu-props="auto"
          label="輸入檢查類型"
          dense
          outlined
        ></v-select>
        <!-- 該題刪除鈕 -->
        <v-btn class="mx-2" fab dark small color="primary" @click="$emit('quesDel')">
          <v-icon dark>mdi-delete-forever</v-icon>
        </v-btn>
      </template>
    </v-card-title>
    <slot name="content"></slot>
  </v-card>
</template>

<script>
export default {
  props: {
    isEdit: { type: Boolean, default: false },
    showInputCheck: { type: Boolean, default: false },
    showIsAssign: { type: Boolean, default: false },
    showIsItemImg: { type: Boolean, default: false },    
    showIsRequired: { type: Boolean, default: true },
    maxwidth: { type: Number, default: null },
    ques: { type: Object, default: null },
  },
  watch: {
    isAssign(newValue, oldValue) {
      // 如果指定檢核 isAssign 題目變動，檢查所選的 inputCheck 是否可以為指定檢核類型
      // 如果輸入檢查不是指定檢核合法的輸入檢查類型，或是空值(指定檢核題一定得選指定檢核類型)，就重新設置為第一個值
      window.console.log(this.ques.inputCheck)
      window.console.log(this.inputCheck)
      if (
        !this.inputCheck.some((x) => x.inputCheck === this.ques.inputCheck) ||
        this.ques.inputCheck === null
      ) {
        this.ques.inputCheck = this.inputCheck[0].inputCheck
      }
      // 讓指定檢核切換的時候，是否必填寫也連動
      this.ques.isRequired = newValue
    },
  },
  computed: {
    // 提供 watcher 監看題目指定檢核類型 isAssign值 的改變
    isAssign() {
      return this.ques.isAssign
    },
    // 決定本題指定檢核題目選項可不可以選擇
    // 如果已經有指定檢核題 // 且 // 本題不是指定檢核題目(是的話必須可取消) // 就不能選擇
    isAssignDisabled() {
      return (
        this.$store.state.ques.list.filter((q) => q.isAssign === true).length > 0 &&
        !this.ques.isAssign
      )
    },
    // 本題可用的輸入檢查下拉式選單選項，相依於是否為指定檢核題目
    // 如果是指定檢核題目可以用的入入檢查會被限縮
    inputCheck() {
      let ques = this.$store.state.ques
      if (this.ques.isAssign) {
        // 取出 assignCheck 裡面合法的 inputCheck code
        let availableList = ques.assignCheck.map((x) => x.inputCheck)
        // 根據 validate inputCheck code 過濾出 inputCheck 選單物件，且不保留選擇的選項(null)
        return ques.inputCheck.filter((x) => availableList.includes(x.inputCheck))
      }
      return ques.inputCheck
    },
  },
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
